import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import PageHero from './components/PageHero';
import IntroSection from './components/IntroSection';
import AttractionsSection from './components/AttractionsSection';
import ConcernsSection from './components/ConcernsSection';
import RecommendedSection from './components/RecommendedSection';
import ApplicationCTA from './components/ApplicationCTA';

export default function RecruitPage() {
  useSEO({
    title: '採用情報 | まごころヘルパー - 介護職・ヘルパー募集【逗子市】無資格可',
    description: '逗子市のまごころヘルパーでは介護職・ヘルパーを募集中。正職員(月給21.5万円~28.5万円)、パート・バイト(時給1,800円~2,500円)。無資格・未経験可、資格取得支援制度あり。JR東逗子駅徒歩7分、京急逗子葉山駅徒歩2分。訪問介護の仕事で地域の皆様に貢献しませんか。',
    keywords: '介護職求人,ヘルパー募集,逗子市,まごころヘルパー,無資格可,未経験可,訪問介護,採用情報',
    path: '/recruit',
    schema: {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "介護職/ヘルパー",
      "description": "訪問介護(身体介護・生活援助・服薬確認など)のお仕事。無資格・未経験可。資格取得支援制度あり。",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "まごころヘルパー",
        "sameAs": `${import.meta.env.VITE_SITE_URL}/`
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "逗子5-7-17 コーポ高木101",
          "addressLocality": "逗子市",
          "addressRegion": "神奈川県",
          "postalCode": "249-0006",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 215000,
          "maxValue": 285000,
          "unitText": "MONTH"
        }
      },
      "employmentType": ["FULL_TIME", "PART_TIME"],
      "datePosted": new Date().toISOString().split('T')[0],
      "validThrough": new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().split('T')[0],
      "url": `${import.meta.env.VITE_SITE_URL}/recruit`
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PageHero />
      <AttractionsSection />
      <ConcernsSection />
      <RecommendedSection />
      <IntroSection />
      <ApplicationCTA />
    </div>
  );
}
